<style>
    .loaderContent {
        background-color: #fff;
        padding: 5%;
        text-align: center;
    }
    .addressBox {
        margin-top: 20px;
        background-color: rgb(109 221 24);
        padding: 1%;
        text-align: center;
        width: 50%;
        margin: 0 auto;
    }
</style>
<template>
    <div class="content-holder">
        <div class="form-holder acct-transfer">
            <ul id="fundsForm" class="align-items-start">
                <li>
                    <label for="">{{$t("deposit.account_type")}}</label>
                    <div class="position-relative w-100">
                        <select
                            class="drop-search d-block"
                            name="account_type"
                            v-model="account_type"
                            @change="
                trading_acc = '';
                submitted = false;
              "
                        >
                            <option value="" disabled>{{$t("deposit.select_type")}}</option>
                            <!--  <option value="0">Demo</option> -->
                            <option value="1">{{$t("deposit.live")}}</option>
                        </select>
                        <span class="text-danger" v-if="account_type == '0' && submitted && error.account">{{ error.account }}</span>
                    </div>
                </li>
                <!-- <li v-if="account_type != ''">
          <label for="">Trading Account</label>
          <div class="position-relative w-100">
            <AccountsDropdown />
            <span class="text-danger" v-if="submitted && error.account">{{
              error.account
            }}</span>
          </div>
        </li> -->
                <li class="half-width">
                    <label for="">{{$t("deposit.trading_account")}}</label>
                    <div class="position-relative w-100">
                        <select
                            class="form-control d-block"
                            name="trading_acc"
                            v-model="trading_acc"
                            ref="tradingAccount"
                            @change="selectTradingAccount(); submitted = false;"
                        >
                            <option value="" disabled>{{$t("deposit.select_trading_account")}}</option>
                            <!-- <option v-for="account of GetTradingAccount" :value="account.account_id" :key="account.account_id" >
                                {{ account.account_id }} ({{   account.demo_live == "1" ? "Live" : "Demo" }})
                            </option> -->
                            <optgroup label="Live MT4">
                                <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key="index">{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT5">
                                <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key="index">{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live ZTP">
                                <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key="index">{{list.account_id}}</option>
                            </optgroup>
                        </select>

                        <span class="text-danger" v-if="submitted && error.selectTrading">{{ error.selectTrading }}</span>
                    </div>
                    <!--  <ErrorMessage name="trading_acc" /> -->
                </li>
                <li v-if="store.lastSelectedAccount.account_id && account_type == '0'" class="currency">
                    <label for="">{{$t("deposit.balance")}}</label>
                    <div class="position-relative w-100">
                        <input type="text" name="amounts" class="d-block" placeholder="Enter deposit amount" v-model="store.tradingAccountDetail.margin_detail.balance" disabled />
                        <!-- <div class="cur">USD</div> -->
                        <span class="text-danger" v-if="submitted && error.amount">{{ error.amount }}</span>
                    </div>
                    <a href="#" class="btn btn-blue popup-link-holder" @click="CheckFund(); $parent.deposit_amount = '';">
                        {{$t("deposit.fund")}}
                    </a>
                </li>
                <li v-if="store.lastSelectedAccount.account_id && account_type == '1'">
                    <label for="">{{$t("deposit.balance")}}</label>
                    <div class="position-relative w-100">
                        <input :disabled="true" type="text" :value="store.tradingAccountDetail.margin_detail.balance" class="d-block" />
                    </div>
                </li>
                <li v-if="store.lastSelectedAccount.account_id && account_type == '1'">
                    <label for="">{{$t("deposit.amount")}}</label>
                    <div class="position-relative w-100">
                        <input type="text" name="amount" placeholder="Enter deposit amount" v-model="amount" class="d-block" ref="amount"/>
                        <!-- <div class="cur">USD</div> -->
                        <span class="text-danger" v-if="submitted && error.msg">{{ error.msg }}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div v-if="account_type == 1">
            <div v-if="account_type == 1" class="dep-nav">
                <ul>
                    <li v-for="type in getMethodsList" :key="type" :class="type == selectedMethod ? 'active' : ''">
                        <a @click="setDepositType(type)">{{ type }}</a><!--  v-if="depositOptions[type]" -->
                    </li>
                </ul>
            </div>

            <div v-if="selectedMethod == 'All'" class="table-holder table-holder2 t-center">
                <table class="fixedLastColumn" v-for="type in updatedKeys" :key="type">
                    <tr v-if="allMethods(type).filter(v=>checkPaymentOptionEligibility(v.id)).length"><!--1` depositOptions[type] &&  -->
                        <th>{{ type }}</th>
                        <th>{{$t("deposit.region")}}</th>
                        <th>{{$t("deposit.currencies")}}</th>
                        <th>{{$t("deposit.processing_time")}}</th>
                        <th>{{$t("deposit.action")}}</th>
                    </tr>
                    <tbody v-for="method,i in allMethods(type)" :key="i">
                        <tr v-if="checkPaymentOptionEligibility(method.id)">
                            <td><img :src="`assets/images/${method.image}`" alt="" style="height: 50px; width: 120px; object-fit: contain;" /></td>
                            <td>{{ method.region }}</td>
                            <td>{{ method.currencies }}</td>
                            <td>{{ method.processingTime }}</td>
                            <td>
                                <button type="button" class="btn btn-blue disabled" v-if="method.id == 20 && !checkSafari()" title="Apple pay is only available in Safari browser">
                                   {{$t("deposit.fund")}}
                                </button>
                                <button type="button" @click="startFunding(method.methodID, method.minimumDeposit, method.currencies, method.name,method.id,method.key)" class="btn btn-blue" v-else-if="method.name != 'FNB'">
                                   {{$t("deposit.fund")}}
                                </button>
                                <button type="button" class="btn btn-blue" v-on:click="viewMore = method.name" v-else>{{$t("deposit.view_more")}}</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="table-holder table-holder2 t-center">
                <table>
                    <tr v-if="allMethods(selectedMethod).filter(v=>checkPaymentOptionEligibility(v.id)).length">
                        <th>{{ selectedMethod }}</th>
                        <th>{{$t("deposit.region")}}</th>
                        <th>{{$t("deposit.currencies")}}</th>
                        <th>{{$t("deposit.processing_time")}}</th>
                        <th>{{$t("deposit.action")}}</th>
                    </tr>
                    <tbody v-for="method,i in allMethods(selectedMethod)" :key="method.name+i">
                        <tr v-if="checkPaymentOptionEligibility(method.id)">
                            <td><img :src="`assets/images/${method.image}`" alt="" style="height: 50px; width: 80px; object-fit: contain;" /></td>
                            <td>{{ method.region }}</td>
                            <td>{{ method.currencies }}</td>
                            <td>{{ method.processingTime }}</td>
                            <td>
                                <button type="button" class="btn btn-blue disabled" v-if="method.id == 20 && !checkSafari()" title="Apple pay is only allow in Safari browser">
                                    {{$t("deposit.fund")}}
                                </button>
                                <button type="button" @click="startFunding(method.methodID, method.minimumDeposit, method.currencies, method.name,method.id,method.key)" class="btn btn-blue" v-else-if="method.name != 'FNB'">
                                    {{$t("deposit.fund")}}
                                </button>
                                <button type="button" class="btn btn-blue" v-on:click="viewMore = method.name" v-else>{{$t("deposit.view_more")}}</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table-holder table-holder2 t-center d-flex align-items-start" style="margin-top: 40px;" v-if="viewMore && (selectedMethod == 'Bank Wire' || selectedMethod == 'All')">
                <table style="margin-right: 40px !important;" v-if="viewMore == 'FNB'">
                    <!-- <tr>
                        <th colspan="2">EFG USD</th>
                    </tr> -->
                    <tr>
                        <td>{{$t("deposit.currency")}}</td>
                        <td>{{$t("deposit.zar")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.swift_code")}}</td>
                        <td>FIRNZAJJXXX</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.beneficiarys_name")}}</td>
                        <td>{{$t("deposit.beneficiarys_name_des")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.account_number")}}</td>
                        <td>{{$t("deposit.user_account_number")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.bank_address")}}</td>
                        <td>{{$t("deposit.bank_address_info")}}</td>
                    </tr>
                </table>
                <table v-if="viewMore == 'Dixipay'">
                    <tr>
                        <th colspan="2">{{$t("deposit.dixipay")}}</th>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.bank_name")}}</td>
                        <td>{{$t("deposit.bank_name_info")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.swift_code")}}</td>
                        <td>{{$t("deposit.swift_code_info")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.beneficiarys_name")}}</td>
                        <td>{{$t("deposit.beneficiarys_name_info")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.iban")}}</td>
                        <td>{{$t("deposit.iban_no")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.currency")}}</td>
                        <td>{{$t("deposit.eur")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.city")}}</td>
                        <td>{{$t("deposit.city_info")}}</td>
                    </tr>
                    <tr>
                        <td>{{$t("deposit.country")}}</td>
                        <td>{{$t("deposit.country_info")}}</td>
                    </tr>
                    <tr>
                        <td colspan="2"><span>*</span> {{$t("deposit.dixipay_note")}}</td>
                    </tr>
                </table>
            </div>
            <SkrillForm :transaction_id="paymentID" :account_id="store.lastSelectedAccount.account_id" :currency_selected="store.lastSelectedAccount.currency" :amount="amount" />
            <div class="loaderOverlayFull" v-if="walletAddress">
                <div class="loaderContent">
                    <div style="margin-bottom: 20px;">
                        <p>
                            {{$t("deposit.you_can_deposit")}} <!-- bitcoins -->{{walletCurrency}} {{$t("deposit.you_can_deposit_msg")}}
                        </p>
                        <div class="addressBox">
                            <strong>{{ walletAddress }}</strong>
                            <div class="position-absolute">
                                <button class="copy" type="button" @click="copy(walletAddress)">{{$t("deposit.copy")}}!</button>
                                <p class="copytext" v-show="copyMsg != ''">{{ copyMsg }}</p>
                            </div>
                        </div>
                    </div>
                    <button type="button" @click="walletAddress = null; walletCurrency = ''; copyMsg = ''" class="btn btn-blue">
                        {{$t("deposit.done")}}
                    </button>
                    <!-- <p style="color: #ff0000; margin-top: 25px;" v-if="walletCurrency != 'BTC'">* {{$t("deposit.network_msg")}}</p> -->
                    <p style="color: #ff0000; margin-top: 25px;" v-if="walletCurrency != 'BTC'">
                        *<span v-if="['ETH','USDT','USDC'].includes(walletCurrency)">{{walletCurrency}} ERC20 deposits are only supported using the ERC20 network/chain. Any transaction made to any other network/chain cannot be reversed.</span>
                        <span v-else-if="['TRXUSDT','TRXUSDC'].includes(walletCurrency)">{{walletCurrency}} deposits are only supported using the TRC20 network/chain. Any transaction made to any other network/chain cannot be reversed.</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useMainStore } from "@/store";
    //import AccountsDropdown from "@/components/shared/AccountsDropdown";
    import SkrillForm from "@/components/shared/SkrillForm";
    export default {
        setup() {
            const store = useMainStore();
            return { store };
        },
        components: {
            //AccountsDropdown,
            SkrillForm,
        },
        data() {
            return {
                name: "deposit",
                width: 0,
                walletAddress: null,
                walletCurrency: '',
                selectedMethod: "All",
                amount: 0,
                minimumAmount: 10,
                error: {
                    account: null,
                    amount: null,
                    msg: null,
                    selectTrading: null,
                },
                paymentID: null,
                submitted: false,
                account_type: "1",
                trading_acc: "",
                copyMsg: "",
                viewMore: "",
                depositOptions: {
                    'All': true,
                    "Bank Cards": true,
                    "E-Wallet": true,
                    'Cryptos': true,
                    "Bank Wire": true,
                },
            };
        },
        watch: {
            amount() {
                if (this.minimumAmount && this.store.lastSelectedAccount.currency) {
                    if (parseFloat(this.amount) < this.minimumAmount) {
                        this.error.amount = `Minimum deposit amount is ${this.COMMON.priceWithCurrency(this.store.lastSelectedAccount, this.minimumAmount)}`;
                    } else {
                        this.submitted = false;
                        this.error.amount = null;
                    }
                }
            },
        },
        computed: {
            updatedKeys() {
                return this.static_vars.depositMethods.keys.filter((i) => i != "All" && i != "AAAFx Wallet");
            },
            GetTradingAccount() {
                return this.store.tradingAccounts.records.filter((val) => val.demo_live == this.account_type).map((i) => i);
            },
            getMethodsList(){
                return this.static_vars.depositMethods.keys.filter(v=>v == 'All'|| this.allMethods(v).filter(k=>this.checkPaymentOptionEligibility(k.id)).length)
            }
        },
        mounted() {
            this.width = window.innerWidth;
            this.trading_acc = this.store.lastSelectedAccount.demo_live == "1" ? this.store.lastSelectedAccount.account_id : "";
        },
        methods: {
            checkSafari(){
                var ua = navigator.userAgent.toLowerCase(); 
                if (ua.indexOf('safari') != -1) { 
                    if (ua.indexOf('chrome') > -1) {
                        return false
                    } else {
                        return true
                    }
                }else{
                    return false
                }
            },
            MergeAcc(acc_type, platform) {
                let demoMT4 = this.store.tradingAccounts.records.filter((i) => i.demo_live == acc_type && i.platform == platform).map((val) => val);
                return demoMT4 || [];
            },
            copy(data) {
                try {
                    navigator.clipboard.writeText(data);
                    this.copyMsg = "Copied";
                    setTimeout(() => {
                        this.copyMsg = "";
                    }, 3000);
                } catch (e) {
                    this.copyMsg = "Unable to copy";
                    setTimeout(() => {
                        this.copyMsg = "";
                    }, 3000);
                }
            },
            CheckFund() {
                this.submitted = true;
                // if (
                //   (Object.keys(this.store.tradingAccountDetail.margin_detail).length == 0) ||  (parseInt(this.store.tradingAccountDetail.margin_detail.balance) < 0 ||
                //   parseInt(this.store.tradingAccountDetail.margin_detail.balance) <
                //     this.minimumAmount)
                // ) {
                //   this.submitted = true;
                //   this.$parent.AddepsoitFund = false;
                //   this.error.account = null;
                //   if (this.trading_acc != "") {
                //     this.error.amount = `Minimum deposit amount is ${
                //       this.static_vars.currency[this.store.lastSelectedAccount.currency]
                //     }${Math.abs(this.minimumAmount)}`;
                //   } else {
                //     this.error.selectTrading = "Please select trading account";
                //   }
                // }
                if (this.trading_acc == "") {
                    this.error.selectTrading = "Please select trading account";
                } else {
                    this.error.amount = null;
                    this.submitted = false;
                    this.$parent.AddepsoitFund = true;
                }
            },
            selectTradingAccount() {
                let acct = this.store.tradingAccounts.records.find((i) => i.account_id == this.trading_acc);
                let keys = {
                    dataRequired: {
                        margin_detail: true,
                        open_trades: false,
                        history: false,
                        account_detail: false,
                    },
                };
                this.store.setLastSelectedAccount(acct, keys, false, "");
            },
            setDepositType(e) {
                this.selectedMethod = e;
                this.viewMore = "";
            },
            allMethods(type) {
                if ([/*20079,*/29236,17580,18124].includes(this.store.user.profile.user_id)) {
                    return this.static_vars.depositMethods.testmethods.filter((i) => i.type === type);
                } else {
                    return this.static_vars.depositMethods.methods.filter((i) => i.type === type);
                }
            },

            checkPaymentOptionEligibility(option) {
                //console.log("checkPaymentOptionEligibility----------",this.store.user.country.toString())
                let countries = this.static_vars.paymentOptionsForCountry[this.store.user.country.toString()];
                //option = option.toString()
                // let countries = this.static_vars.paymentOptionsForCountry['"MK"'];
                if (countries) {
                    if (option == "0") {
                        let key = "Ecommpay MC";
                        return countries[key];
                    } else if (option == "1") {
                        let key = "Ecommpay Visa";
                        /*if (countries["Ecommpay Visa"] || countries["Ecommpay MC"]) {
                            this.depositOptions["Bank Cards"] = true;
                        } else {
                            this.depositOptions["Bank Cards"] = false;
                        }*/
                        return countries[key];
                    } else if (option == "2") {
                        let key = "Virtual Pay";
                        // console.log('==============>0',option,key,countries,this.store.user.country.toString())
                        /*if (countries["Virtual Pay"]) {
                            this.depositOptions["E-Wallet"] = true;
                        } else {
                            this.depositOptions["E-Wallet"] = false;
                        }*/
                        return countries[key];
                    } else if (option == "3") {
                        let key = "Skrill";
                        /*if (countries["Skrill"] || countries["Virtual Pay"]) {
                            this.depositOptions["E-Wallet"] = true;
                        } else {
                            this.depositOptions["E-Wallet"] = false;
                        }*/
                        return countries[key];
                    } else if (option == "4") {
                        let key = "Neteller";
                        /*if (countries["Virtual Pay"] || countries["Skrill"] || countries["Neteller"]) {
                            this.depositOptions["E-Wallet"] = true;
                        } else {
                            this.depositOptions["E-Wallet"] = false;
                        }*/
                        return countries[key];
                    } else if (option == "9") {
                        let key = "Help2Pay";
                        return countries[key];
                    } else if (option == "10") {
                        let key = "PayRetailers";
                        return countries[key];
                    } else if (option == "11") {
                        let key = "AstroPay";
                        return countries[key];
                    } else if (option == "12") {
                        let key = "FairPay Cash";
                        return countries[key];
                    } else if (option == "13") {
                        let key = "FairPay Online";
                        return countries[key];
                    } else if (option == "14") {
                        //let key = "FNB";
                        //return countries[key];
                        if(this.store.user.country.toString() == "ZA"){
                            return true;
                        }else{
                            return false;
                        }
                    } else if (option == "15") {
                        //if( countries["Help2Pay"] || countries["Pay Retailers"] || countries["AstroPay"] || countries["FairPay Cash"] || countries["FairPay Online"] || countries["Eurobank"]) { this.depositOptions["Bank Wire"] = true } else{ this.depositOptions["Bank Wire"] = false }
                        return true;
                    } else if (option == "16") {
                        let key = "Google Pay";
                        return countries[key];
                    } else if (option == "20") {
                        let key = "Apple Pay";
                        return countries[key];
                    } else if (option == 21) {
                        let key = "Swiffy";
                        return countries[key]/* && this.store.user.profile.user_id == 20081*/;
                    } else if (option == "17") {
                        let key = "KoraPay";
                        return countries[key];
                    } else if (option == "5" || option == "6" || option == "7" || option == "8" || option == "23" || option == "24") {
                        let key = "Cryptos";
                        /*if (countries[key]) {
                            this.depositOptions["Cryptos"] = true;
                        } else {
                            this.depositOptions["Cryptos"] = false;
                        }*/
                        // return [23,24].includes(parseInt(option)) ? ( [20081, 20079,4549, 20079].includes(this.store.user.profile.user_id)) : countries[key];
                        return countries[key];
                    }/* && countries[key] */
                } else {
                    return false;
                }
            },

            startFunding(method_id, min, currency, method_name,id,pay_key) {
                this.viewMore = "";
                if (this.account_type == "1") {
                    if (this.trading_acc != "") {
                        this.error.selectTrading = null;
                        this.error.account = "";
                        this.submitted = true;
                        // FTD is $100
                        if (this.$route.path != "/dashboard") {
                            this.minimumAmount = min;
                        }
                        if (!this.store.lastSelectedAccount.account_id) {
                            this.error.account = "Please select an account first";
                            document.getElementById("fundsForm").scrollIntoView({ behavior: "smooth" });
                            return;
                        } else {
                            this.error.account = null;
                        }
                        let trading_acc =  this.store.tradingAccounts.records.find((val) => val.account_id == this.trading_acc)
                        /*console.log(trading_acc,trading_acc.account_type,this.minimumAmount = this.static_vars.accountTypes.find(v=>v.value == trading_acc.account_type))
                        console.log(this.minimumAmount = this.static_vars.accountTypes.find(v=>v.value == trading_acc.account_type).min_deposit)*/
                        if ((this.store.depositsList.records || []).length == 0) {
                            if(trading_acc && this.static_vars.accountTypes.find(v=>v.value == trading_acc.account_type)){
                                this.minimumAmount = this.static_vars.accountTypes.find(v=>v.value == trading_acc.account_type).min_deposit
                            }else{
                                this.minimumAmount = 100
                            }
                        }
                        if(!Number(this.amount)){
                            this.error.msg = "The amount field may only contain numeric characters."
                            this.$refs.amount.focus()
                            return;
                        }
                        if (this.amount < this.minimumAmount) {
                            this.error.msg = `Minimum deposit amount is ${this.COMMON.priceWithCurrency(this.store.lastSelectedAccount, this.minimumAmount)}`;
                            // document.getElementById("fundsForm").scrollIntoView({ behavior: "smooth" });
                            this.$refs.amount.focus()
                            return;
                        } else {
                            this.error.msg = null;
                            this.submitted = false;
                        }
                        let data = {
                            account_id: this.store.lastSelectedAccount.account_id,
                            amount: parseFloat(this.amount),
                            currency: this.store.lastSelectedAccount.currency,
                        };

                        if (method_id == 2) {
                            data["method_id"] = "2";
                            data["payment_method_email"] = this.store.user.email;
                        }
                        if (method_id == 3) {
                            data["method_id"] = "3";
                            data["payment_method_email"] = this.store.user.email;
                        }
                        if (method_id == 17) {
                            data["method_id"] = "17";
                        }
                        if (method_id == 18) {
                            data["currency"] = currency;
                            data["method_id"] = "18";
                        }

                        if (method_name == "Google Pay") {
                            data["method_name"] = method_name;
                        }
                        if (method_name == "Apple Pay") {
                            data["method_name"] = method_name;
                        }
                        data['id'] = id
                        try {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: "addfund",
                                fundMethod: method_name,
                            });
                        } catch (e) {
                            console.log(e);
                        }
                        if (this.store.user.profile.user_id == 20079 || this.store.user.profile.user_id == 29236 || this.store.user.profile.user_id == 17580 || this.store.user.profile.user_id == 18124) {
                            data['id'] = id
                            let obj = this.static_vars.depositMethods.others[pay_key] || null;
                            if(obj && obj[this.store.user.country.toString()]){
                                data['id'] = obj[this.store.user.country.toString()]
                            }
                        }
                        this.store
                            .generateDepositURL(data, true)
                            .then((response) => {
                                if (method_id == 2) {
                                    this.paymentID = response.trans_id;
                                    setTimeout(() => {
                                        document.getElementById("skrillForm").submit();
                                    }, 1000);
                                }
                                if (method_id == 18) {
                                    this.walletAddress = response.address;
                                    this.walletCurrency = data.currency;
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        this.submitted = true;
                        this.error.selectTrading = "Please select trading account";
                        this.$refs.tradingAccount.focus()
                    }
                } else {
                    this.submitted = true;
                    this.error.selectTrading = null;
                    this.error.account = "Please Select Live account";
                }
            },
        },
        created() {
            if (this.$route.path === "/dashboard") {
                this.minimumAmount = 100;
            }
        },
    };
</script>
